import { useEffect } from 'react';

const TEKST =
  'Je hebt wijzigingen die nog niet zijn opgeslagen. Weet je zeker dat je wilt sluiten? Je aanpassingen gaan dan verloren.';

/**
 * Waarschuwt zodra er niet-opgeslagen wijzigingen in een bewerk-dialoog staan.
 *
 * Twee wegen naar buiten, dus twee waarschuwingen: het tabblad sluiten of
 * verversen (`beforeunload`, door de browser afgehandeld) en het dialoogvenster
 * zelf sluiten (`bevestigSluiten`, aan te roepen vanuit Annuleren, het kruisje
 * en de klik naast het venster).
 *
 * Bewust geen router-integratie: navigeren binnen de app sluit deze dialogen
 * niet, en een blocker per route is een tweede, zwaardere val.
 */
export function useOnbewaardeWijzigingen(vuil: boolean): { bevestigSluiten: () => boolean } {
  useEffect(() => {
    if (!vuil) return;
    const handler = (e: BeforeUnloadEvent): void => {
      // De browser toont zijn eigen tekst; preventDefault is het enige signaal
      // dat de dialoog daadwerkelijk laat verschijnen.
      e.preventDefault();
      e.returnValue = TEKST;
    };
    window.addEventListener('beforeunload', handler);
    return () => window.removeEventListener('beforeunload', handler);
  }, [vuil]);

  return { bevestigSluiten: () => !vuil || window.confirm(TEKST) };
}
